import React, { useEffect, useState } from "react";
import Slider from 'react-slick';
import ImageAward1 from "../../images/awards-icon-1.png";
import ImageAward2 from "../../images/awards-icon-2.png";
import ImageAward3 from "../../images/awards-icon-3.png";
import ImageAward4 from "../../images/awards-icon-4.png";
import ImageAward5 from "../../images/awards-icon-5.png";
import ImageAward6 from "../../images/awards-icon-6.png";
import ImageAward7 from "../../images/awards-icon-7.png";
import ImageAward8 from "../../images/awards-icon-8.png";
import ImageAward9 from "../../images/awards-icon-9.png";
import ImageAward10 from "../../images/awards-icon-10.png";
import ImageProfile1 from "../../images/profile-jacqui-sabo.png";
import ImageProfile2 from "../../images/profile-jessica-williams.png";
import ImageProfile3 from "../../images/profile-zora-zamecnikova.png";
import ImageProfile4 from "../../images/profile-eric-griego.png";
import ImageProfile5 from "../../images/profile-brittany-canaski.png";
import ImageProfile6 from "../../images/Profile-Ian-Ray.png";


export default function CsResult() {
    const _isMounted = false;
    const [isMobile, setisMobile] = useState(false);

    useEffect(() => {
        const setValues = () => {
            setisMobile(window.innerWidth <= 767);
        };
        setValues();
        window.addEventListener('resize', () => {
            setValues();
        });
        return () => {
            window.removeEventListener('resize', () => {
                setValues();
            });
        };
    });


    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    };

    const settings1 = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                }
            },
        ]
    };

    return (
        <div className="cs-result-section  section-gap-large">
            <div className="container-small section-gap">
                <div className="cs-result-content">
                    <h3>The Result</h3>
                    <p>Salesmate has grown into a multi-million-dollar revenue platform, won multiple industry awards, and achieved an NPS of 91.  The customers love using it to transform the way modern businesses grow their revenue and customer relationships. </p>
                </div>
                <div className="cs-result-content">
                    <div className="awards-icon-grid">
                        {isMobile && <Slider {...settings1}>
                            <div className="award-icon">
                                <img src={ImageAward1} width="75px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward2} width="100px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward3} width="110px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward4} width="75px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward5} width="102px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward6} width="70px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward7} width="78px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward8} width="100px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward9} width="95px" alt="Award 1" title="Award 1" />
                            </div>
                            <div className="award-icon">
                                <img src={ImageAward10} width="110px" alt="Award 1" title="Award 1" />
                            </div>
                        </Slider>}
                        {!isMobile && <>
                            <div className="d-flex flex-wrap align-v-center justify-space">
                                <div className="award-icon">
                                    <img src={ImageAward1} width="75px" alt="Award 1" title="Award 1" />
                                </div>
                                <div className="award-icon">
                                    <img src={ImageAward2} width="100px" alt="Award 1" title="Award 1" />
                                </div>
                                <div className="award-icon">
                                    <img src={ImageAward3} width="110px" alt="Award 1" title="Award 1" />
                                </div>
                                <div className="award-icon">
                                    <img src={ImageAward4} width="75px" alt="Award 1" title="Award 1" />
                                </div>
                                <div className="award-icon">
                                    <img src={ImageAward5} width="102px" alt="Award 1" title="Award 1" />
                                </div>

                            </div>
                            <div className="d-flex flex-wrap align-v-center justify-space">

                                <div className="award-icon">
                                    <img src={ImageAward6} width="70px" alt="Award 1" title="Award 1" />
                                </div>
                                <div className="award-icon">
                                    <img src={ImageAward7} width="78px" alt="Award 1" title="Award 1" />
                                </div>
                                <div className="award-icon">
                                    <img src={ImageAward8} width="100px" alt="Award 1" title="Award 1" />
                                </div>
                                <div className="award-icon">
                                    <img src={ImageAward9} width="95px" alt="Award 1" title="Award 1" />
                                </div>
                                <div className="award-icon">
                                    <img src={ImageAward10} width="110px" alt="Award 1" title="Award 1" />
                                </div>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
            <div className="testimonial-slider">
                <div className="container">
                    <Slider {...settings}>
                        <div className="testimonial-item">
                            <div className="d-flex testimonial-top">
                                <div className="testimonial-img">
                                    <img src={ImageProfile1} alt="Jacqui Sabo" title="Jacqui Sabo" />
                                </div>
                                <div className="testimonial-title">
                                    <h5>Jacqui Sabo</h5>
                                    <small>Vice President - Faciliteq</small>
                                </div>
                            </div>
                            <div className="testimonial-bottom">
                                <p>We can see our pipeline, including the sales process stages and the dollar volume at each stage. Since our inception 90 days ago, our pipeline has grown 100%</p>
                            </div>
                        </div>
                        <div className="testimonial-item">
                            <div className="d-flex testimonial-top">
                                <div className="testimonial-img">
                                    <img src={ImageProfile2} alt="Jessica Williams" title="Jessica Williams" />
                                </div>
                                <div className="testimonial-title">
                                    <h5>Jessica Williams</h5>
                                    <small>Fashion Designer - Irregular Exposure</small>
                                </div>
                            </div>
                            <div className="testimonial-bottom">
                                <p>Salesmate is very easy to use and affordable. It’s a one stop shop when it comes to managing my clients.</p>
                            </div>
                        </div>
                        <div className="testimonial-item">
                            <div className="d-flex testimonial-top">
                                <div className="testimonial-img">
                                    <img src={ImageProfile3} alt="Zora Zamecnikova" title="Zora Zamecnikova" />
                                </div>
                                <div className="testimonial-title">
                                    <h5>Zora Zamecnikova</h5>
                                    <small>Brand Ambassador</small>
                                </div>
                            </div>
                            <div className="testimonial-bottom">
                                <p>Very convenient and easy CRM with all the necessary features, quick and professional support</p>
                            </div>
                        </div>
                        <div className="testimonial-item">
                            <div className="d-flex testimonial-top">
                                <div className="testimonial-img">
                                    <img src={ImageProfile4} alt="Eric Griego" title="Eric Griego" />
                                </div>
                                <div className="testimonial-title">
                                    <h5>Eric Griego</h5>
                                    <small>VP, Business Development – HoldMyTicket</small>
                                </div>
                            </div>
                            <div className="testimonial-bottom">
                                <p>If you are looking for an intuitive, lightweight, and customizable sales platform, you have to get a demo from the Salesmate team.</p>
                            </div>
                        </div>
                        <div className="testimonial-item">
                            <div className="d-flex testimonial-top">
                                <div className="testimonial-img">
                                    <img src={ImageProfile5} alt="Brittany Canaski" title="Brittany Canaski" />
                                </div>
                                <div className="testimonial-title">
                                    <h5>Brittany Canaski</h5>
                                    <small>Director, Work For Your Beer</small>
                                </div>
                            </div>
                            <div className="testimonial-bottom">
                                <p>I’ve been using this platform for over a month now and have seen my productivity double!</p>
                            </div>
                        </div>
                        <div className="testimonial-item">
                            <div className="d-flex testimonial-top">
                                <div className="testimonial-img">
                                    <img src={ImageProfile6} alt="Ian Ray" title="Ian Ray" />
                                </div>
                                <div className="testimonial-title">
                                    <h5>Ian Ray</h5>
                                    <small>CTO – Airshark</small>
                                </div>
                            </div>
                            <div className="testimonial-bottom">
                                <p>Fantastic value for a CRM platform with easy staff onboarding and great back-end webhook integration support.</p>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </div>
    );
}